import billingPlansTemplate from './billingPlans.html';

export default angular
  .module('main.organizations.edit.tabs.billingPlans', [])

  .directive('editOrganizationBillingPlansTab', () => {
    return {
      restrict: 'E',
      template: billingPlansTemplate,
      scope: {},
      controller: ($scope,
                   $q,
                   $state,
                   $filter,
                   $window,
                   utils,
                   ToastsService,
                   EditOrganizationDataProvider) => {
        const $t = $filter('translate');
        const SELECTED_BILLING_PLAN_LOCAL_STORAGE_KEY = 'Selected-Billing-Plan';

        $scope.dataProvider = EditOrganizationDataProvider.instance;

        angular.extend($scope, {
          onBackButtonClick: onBackButtonClick,
          setupBillingAccess: setupBillingAccess,
          gotoPlanDetails: gotoPlanDetails,
        });

        init();

        function init() {
          $scope.loading = true;

          $q.all([
            $scope.dataProvider.organizationResource.init(),
            $scope.dataProvider.organizationIdResource.init(),
            $scope.dataProvider.organizationBillingPlansResource.init(),
          ])
            .then(() => {
              processBillingPlans();
              $scope.loading = false;
            }, () => {
              $scope.loading = false;
            });
        }

        function processBillingPlans() {
          let now = new Date().getTime();
          let billingPlans = angular.copy($scope.dataProvider.organizationBillingPlansResource.value);
          $scope.billingPlans = billingPlans.map(el => {
            el.active = el.startDateMs <= now && el.endDateMs > now;
            return el;
          });
          $scope.loading = false;
        }

        function onBackButtonClick() {
          $scope.dataProvider.activeTab = 'billing';
        }

        function setupBillingAccess() {
          return utils.canISetupBilling;
        }

        function gotoPlanDetails() {
          utils.setStorageItem(SELECTED_BILLING_PLAN_LOCAL_STORAGE_KEY, $scope.billingPlan);
          $state.go('main.billing.plan', {
            from: 'organization',
            organizationId: $scope.dataProvider.organizationIdResource.value,
          });
        }

    }
  };
})
.name;
